<div class="wrapper-content" *ngIf="type==='403'" >
  <div class="wrapper-header" style="padding-top: 50px;">
    <a  class="btn-back" (click)="route.goTo('/')" >
      <svg class="chevron" xmlns="http://www.w3.org/2000/svg" width="28.536" height="17.803" viewBox="0 0 28.536 17.803">
        <path id="chevron" d="M2420,308.188l12.5,12.5,12.5-12.5" transform="translate(-2418.232 -306.42)" fill="none" stroke="#000" stroke-width="5"/>
      </svg> Volver al inicio
    </a>
    <h1 class="text-center">403: Lo sentimos no encontramos el recurso solicitado</h1>
  </div>
</div>
